import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }                            from 'ng-block-ui';
import { DOCUMENT }                                      from '@angular/common';

import { GoogleSsoClientCredentials } from '../../app-lite/google-sso/models/google-sso.client-credentials';
import { GoogleSsoService }           from '../../app-lite/google-sso/google-sso.service';
import { LoginService }               from '../login/login.service';
import { MessagesService }            from '../../app-lite/messages/messages.service';

declare const google : any;

@Component({
  selector: 'wor-google-one-tap',
  template: ''
})
export class GoogleSsoOneTapComponent implements OnDestroy, OnInit {
  @BlockUI('loginBlock') block : NgBlockUI;

  private _gsiScriptUrl = 'https://accounts.google.com/gsi/client';

  constructor (
    @Inject(DOCUMENT)
    private document        : Document,
    private googleSsoService: GoogleSsoService,
    private loginService    : LoginService,
    private messagesService : MessagesService,
    private ngZone          : NgZone
  ) {}

  ngOnDestroy () : void {
    if ( typeof google !== 'undefined' && google?.accounts?.id ) {
      google.accounts.id.cancel();
    }
  }

  ngOnInit () : void {
    if ( this._isOnOauthCallback() ) {
      return;
    }

    this.googleSsoService.getClientCredentials()
    .then(( credentials : GoogleSsoClientCredentials ) => {
      if ( !credentials?.client_id ) {
        return;
      }

      return this.loadScript()
      .then(() => {
        google.accounts.id.initialize({
          client_id            : credentials.client_id,
          callback             : ( response : { credential : string } ) => {
            this.ngZone.run(() => this.handleCredentialResponse(response));
          },
          use_fedcm_for_prompt : false
        });

        google.accounts.id.prompt();
      });
    });
  }

  handleCredentialResponse ( response : { credential : string } ) : void {
    this.block.start();

    this.loginService.loginWithGoogleCredential(response.credential)
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  loadScript () : Promise<void> {
    return new Promise(( resolve, reject ) => {
      const body = this.document?.body;

      if ( !body ) {
        reject();

        return;
      }

      const existingScript = this.document.querySelector(`script[src="${ this._gsiScriptUrl }"]`);

      if ( existingScript ) {
        resolve();

        return;
      }

      const script = this.document.createElement('script');

      script.async   = true;
      script.defer   = true;
      script.src     = this._gsiScriptUrl;
      script.type    = 'text/javascript';
      script.onload  = () => resolve();
      script.onerror = () => reject();

      body.appendChild(script);
    });
  }

  private _isOnOauthCallback () : boolean {
    const queryString = window.location.search || window.location.hash;

    return queryString.indexOf('session_state') >= 0
      || ( queryString.indexOf('code=') >= 0 && queryString.indexOf('state=') >= 0 );
  }
}
